import React, { useEffect, useImperativeHandle, useState } from "react";
import { Button, Input } from "../Elements";
import Modal from "../Modal";
import HtmlTooltip from "../HtmlTooltilp";
import { Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import { Checkbox } from "../Elements";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";

type ComponentProp = {
    updateCallBack: Function
}

const InstallmentDetailModal = React.forwardRef((props: ComponentProp, ref) => {
    const firmInformations = useRecoilValue(tenantState);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [fields, setFields] = useState({
        installment: 0,
        valorDate: "",
        commissionAmount: "",
        status: false,
        serviceCommissionRate: "",
        extraInstallmentCount: "",
        extraInstallmentLowLimit: "",
        extraInstallmentUpLimit: "",
        deferralCount: "",
        deferralLowLimit: "",
        deferralUpLimit: "",
        termUpLimit: "",
        lowerLimit: "",
        upperLimit: "",
        isBusiness: true,
        isIndividual: true,
        paymentSpecCode: "",
        paymentPlanCode: ""
    });

    const [createLoading, setCreateLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        openModal(defaultValues) {
            if (defaultValues.isIndividual || defaultValues.isBusiness) {
                setFields(defaultValues);

            } else {
                setFields({
                    ...defaultValues,
                    isBusiness: true,
                    isIndividual: true,

                })
            }
            setIsModalVisible(true);
            setCreateLoading(false);
        }

    }));

    useEffect(() => {

        props.updateCallBack(fields);
    }, [fields]);

    const onUpdateClick = async () => {
        setIsModalVisible(false);
        // props.updateCallBack(fields);

    }

    const onChangeField = (event, type) => {
        var vvv = "";

        var val = event.target.value;
        if (event.target.type == "checkbox") {
            val = event.target.checked;
        } else {
            val = val.replaceAll(",", "");
        }
        if (type == "number") {
            val = parseInt(val);
        }
        setFields({
            ...fields,
            [event.target.name]: val
        });
    }

    const closeModalValidation = () => {
        var errors = [];
        var message = "";

        if (parseFloat(fields.lowerLimit) > parseFloat(fields.upperLimit) && fields.upperLimit > 0) {
            errors.push({
                name: "lowerLimit",
                message: ""
            });
        }
        if (parseFloat(fields.deferralLowLimit) > parseFloat(fields.deferralUpLimit) && fields.deferralUpLimit > 0) {
            // var message = "Alt limit Üst limitten büyük olamaz.";
            errors.push({
                name: "deferralLowLimit",
                message: ""
            });
        } else
            if (parseFloat(fields.deferralCount) <= 0 && (parseFloat(fields.deferralLowLimit) > 0 || fields.deferralUpLimit > 0)) {
                errors.push({
                    name: "deferralCount",
                    message: "Taksit erteleme sayısı giriniz."
                });
                message = "Taksit erteleme sayısı giriniz."
            }
        if (parseFloat(fields.extraInstallmentLowLimit) > parseFloat(fields.extraInstallmentUpLimit) && fields.extraInstallmentUpLimit > 0) {
            errors.push({
                name: "extraInstallmentLowLimit",
                message: ""
            });
        } else if (fields.extraInstallmentCount <= 0 && (fields.extraInstallmentLowLimit > 0 || fields.extraInstallmentUpLimit > 0)) {
            errors.push({
                name: "extraInstallmentCount",
                message: "Artı taksit sayısı giriniz."
            });

            message = "Artı taksit sayısı giriniz."
        }

        // Checkbox validasyonu
        if (!fields.isBusiness && !fields.isIndividual) {
            errors.push({
                name: "checkbox",
                message: "En az birini seçmelisiniz: Ticari veya Bireysel."
            });
            message = "En az birini seçmelisiniz: Ticari veya Bireysel.";
        }

        if (errors.length > 0) {
            if (!message) {
                message = "Alt limit Üst limitten büyük olamaz.";
            }
            toast.error(message);
            setErrorMessages(errors);
        } else {
            closeModal();
        }
    }

    const closeModal = () => {
        setErrorMessages([]);
        setIsModalVisible(false);

    };

    const FieldTooltip = ({ title, content }) => (
        <HtmlTooltip
            title={
                <React.Fragment>
                    <Typography color="inherit">{title}</Typography>
                    {content}

                </React.Fragment>
            }
        >
            <InfoOutlined className='text-gray-text ml-2 text-contrast-50' fontSize="small" style={{

            }} />
        </HtmlTooltip>
    )

    const inputTextSizeLimitter = (max, min) => {
        return {
            isAllowed: (values) => {
                const { floatValue } = values;
                return floatValue === undefined || floatValue >= (min || 0) && floatValue <= (max || 99);
            }
        }
    }

    const dbDecimalMaxLimit = 999999999999.999999

    const isOnstallment_1 = fields.installment == 1;

    return (
        <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} dialogclassName={"modal-w-42 !mt-20"} >
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-[100%]">
                        <h3 className="text-md leading-6 font-medium text-primary mb-2 ">
                            Taksit Düzenle {`(${isOnstallment_1 ? "Peşin" : fields.installment + " Taksit"})`}

                        </h3>
                        <div className="w-100 ">

                            <div className=" mb-4 p-3 bg-white ">
                                <div className="flex flex-row justify-between items-center  pb-2 mb-2  border-b-2">
                                    <h3 className="font-bold text-contrast-90">
                                        Genel Ayarlar
                                    </h3>
                                </div>
                                <div className="flex-auto w-50 grid grid-cols-3 gap-4">
                                    <div className="">
                                        <Input
                                            name={`commissionAmount`}
                                            value={fields.commissionAmount > 0 ? fields.commissionAmount : ""}
                                            type="text"
                                            className="w-[100%]"
                                            label="Komisyon Oranı"
                                            placeholder="0.00"
                                            onChange={onChangeField}
                                            // mask="99.99"
                                            {...inputTextSizeLimitter()}
                                            currencyformat="true"
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Müşteriye yansıtılacak komisyon oranını giriniz"} />
                                            }
                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`serviceCommissionRate`}
                                            value={fields.serviceCommissionRate}
                                            type="text"
                                            className="w-[100%]"
                                            label="Hizmet Komisyon Oranı"
                                            onChange={(event) => {

                                                onChangeField(event)
                                            }}
                                            currencyformat="true"
                                            placeholder="0.00"
                                            {...inputTextSizeLimitter()}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Banka tarafından uygulanan hizmet komisyon oranını giriniz"} />
                                            }
                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`valorDate`}
                                            value={fields.valorDate > 0 ? fields.valorDate : ""}
                                            className="w-[100%]"
                                            label="Geri Ödeme Gün Sayısı"
                                            mask="999999"
                                            onChange={(event) => {
                                                onChangeField(event, "number")
                                            }}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Bankanın geri ödeme gün sayısını giriniz"} />
                                            }

                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`termUpLimit`}
                                            value={fields.termUpLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Vade Günü Üst Limit"
                                            onChange={(event) => {
                                                onChangeField(event, "number")
                                            }}
                                            mask="999999"
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Seçilen taksitin uygulanabilmesi için gereken vade gününün üst limitini giriniz"} />
                                            }
                                        />
                                    </div>
                                    <div className="">
                                        <div className="flex items-center text-sm  mb-1">
                                            <label className="block text-contrast-70 whitespace-nowrap">
                                                Bireysel & Ticari
                                            </label>
                                            <FieldTooltip title={""}
                                                content={"Banka kart tipini seçiniz"} />
                                        </div>
                                        <div className="flex justify-between">
                                            <Checkbox
                                                name={`isIndividual`}
                                                label="Bireysel Kart"
                                                checked={fields.isIndividual}
                                                type="checkbox"
                                                onChange={(event) => {
                                                    onChangeField(event)
                                                }}
                                                id="isIndividual"
                                            />
                                            <Checkbox
                                                name={`isBusiness`}
                                                label="Ticari Kart"
                                                checked={fields.isBusiness}
                                                type="checkbox"
                                                onChange={(event) => {
                                                    onChangeField(event)
                                                }}
                                                id="isBusiness"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" mb-4 p-3 bg-white ">
                                <div className="flex flex-row justify-between items-center  mb-2 pb-2 border-b-2">
                                    <h3 className="font-bold text-contrast-90">
                                        Taksit Limit Ayarları
                                    </h3>
                                </div>
                                <div className="flex-auto w-50 grid grid-cols-3 gap-4">
                                    <div className="">
                                        <Input
                                            name={`lowerLimit`}
                                            value={fields.lowerLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Ödeme Tutarı Alt Limit"
                                            {...inputTextSizeLimitter(dbDecimalMaxLimit, 0)}
                                            onChange={onChangeField}
                                            currencyformat
                                            isError={errorMessages.findIndex(w => w.name == "lowerLimit") != -1}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Seçilen taksitin uygulanması için gereken ödeme tutarının alt limitini giriniz"} />
                                            }

                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`upperLimit`}
                                            value={fields.upperLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Ödeme Tutarı Üst Limit"
                                            onChange={onChangeField}
                                            {...inputTextSizeLimitter(dbDecimalMaxLimit, 0)}
                                            currencyformat
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Seçilen taksitin uygulanması için gereken ödeme tutarının üst limitini giriniz"} />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" mb-4 p-3 bg-white ">
                                <div className="flex flex-row justify-between items-center  mb-2 pb-2 border-b-2">
                                    <h3 className="font-bold text-contrast-90">
                                        Artı Taksit Ayarları
                                    </h3>
                                </div>
                                <div className="flex-auto w-50 grid grid-cols-3 gap-4">
                                    <div className="">
                                        <Input
                                            name={`extraInstallmentCount`}
                                            value={fields.extraInstallmentCount}
                                            type="text"
                                            className="w-[100%]"
                                            label="Artı Taksit Sayısı"
                                            isError={errorMessages.findIndex(w => w.name == "extraInstallmentCount") != -1}
                                            onChange={(event) => {
                                                onChangeField(event, "number")
                                            }}
                                            mask="9999999999"
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Seçilen taksitte uygulanacak artı taksit sayısını giriniz"} />
                                            }
                                            disabled={isOnstallment_1}
                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`extraInstallmentLowLimit`}
                                            value={fields.extraInstallmentLowLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Artı Taksit Alt Limit"
                                            onChange={onChangeField}
                                            {...inputTextSizeLimitter(dbDecimalMaxLimit, 0)}
                                            isError={errorMessages.findIndex(w => w.name == "extraInstallmentLowLimit") != -1}
                                            currencyformat
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Artı taksit uygulanması için gerekli olan ödeme tutarının alt limitini giriniz"} />
                                            }
                                            disabled={isOnstallment_1}
                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`extraInstallmentUpLimit`}
                                            value={fields.extraInstallmentUpLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Artı Taksit Üst Limit"
                                            onChange={onChangeField}
                                            {...inputTextSizeLimitter(dbDecimalMaxLimit, 0)}
                                            currencyformat
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Artı taksit uygulanması için gerekli olan ödeme tutarının üst limitini giriniz"} />
                                            }
                                            disabled={isOnstallment_1}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" mb-4 p-3 bg-white ">
                                <div className="flex flex-row justify-between items-center mb-2 pb-2 border-b-2 ">
                                    <h3 className="font-bold text-contrast-90">
                                        Taksit Erteleme Ayarları
                                    </h3>
                                </div>


                                <div className="flex-auto w-50 grid grid-cols-3 gap-4">
                                    <div className="">
                                        <Input
                                            name={`deferralCount`}
                                            value={fields.deferralCount}
                                            type="text"
                                            className="w-[100%]"
                                            label="Taksit Erteleme Sayısı"
                                            mask="9999999999"
                                            isError={errorMessages.findIndex(w => w.name == "deferralCount") != -1}
                                            onChange={(event) => {
                                                onChangeField(event, "number")
                                            }}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Seçilen taksitte uygulanacak taksit erteleme sayısını giriniz"} />
                                            }
                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`deferralLowLimit`}
                                            value={fields.deferralLowLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Taksit Erteleme Alt Limit"
                                            {...inputTextSizeLimitter(dbDecimalMaxLimit, 0)}
                                            isError={errorMessages.findIndex(w => w.name == "deferralLowLimit") != -1}
                                            currencyformat
                                            onChange={onChangeField}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Taksit erteleme uygulanması için gerekli olan ödeme tutarının alt limitini giriniz"} />
                                            }
                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`deferralUpLimit`}
                                            value={fields.deferralUpLimit}
                                            type="text"
                                            className="w-[100%]"
                                            label="Taksit Erteleme Üst Limit"
                                            {...inputTextSizeLimitter(dbDecimalMaxLimit, 0)}
                                            currencyformat
                                            onChange={onChangeField}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"Taksit erteleme uygulanması için gerekli olan ödeme tutarının üst limitini giriniz"} />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" mb-4 p-3 bg-white ">
                                <div className="flex flex-row justify-between items-center  mb-2 pb-2 border-b-2">
                                    <h3 className="font-bold text-contrast-90">
                                        ERP Taksit Ayarları
                                    </h3>
                                </div>
                                <div className="flex-auto w-50 grid grid-cols-3 gap-4">
                                    <div className="">
                                        <Input
                                            name={`paymentSpecCode`}
                                            value={fields.paymentSpecCode}
                                            type="text"
                                            className="w-[100%]"
                                            label="ERP Hareket Özel Kodu"
                                            onChange={onChangeField}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"..."} />
                                            }

                                        />
                                    </div>
                                    <div className="">
                                        <Input
                                            name={`paymentPlanCode`}
                                            value={fields.paymentPlanCode}
                                            type="text"
                                            className="w-[100%]"
                                            label="ERP Plan Kodu"
                                            onChange={onChangeField}
                                            labelInfoIcon={
                                                <FieldTooltip title={""}
                                                    content={"..."} />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 mt-4 sm: sm:flex sm:justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => closeModalValidation()}
                    >
                        Kapat
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default InstallmentDetailModal;